import { render, staticRenderFns } from "./Guests.vue?vue&type=template&id=2806ad34&scoped=true&"
import script from "./Guests.vue?vue&type=script&lang=js&"
export * from "./Guests.vue?vue&type=script&lang=js&"
import style0 from "./Guests.vue?vue&type=style&index=0&id=2806ad34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2806ad34",
  null
  
)

export default component.exports